import { GlobalState, UI } from '@leverege/ui-redux';

/**
 * Replaces all :name arguments in the path with their
 * values in match.params
 */
const resolve = (path, match) => {
  if (match == null || match.params == null || path == null) {
    return path;
  }
  const {
    params
  } = match;
  const arr = path.split('/');
  for (let n = 0; n < arr.length; n++) {
    if (arr[n][0] === ':') {
      const key = arr[n].substring(1);
      if (key === 'persona') {
        const p = UI.get(GlobalState.get())?.activePersona;
        arr[n] = p?.name || 'default';
      } else if (params[key]) {
        arr[n] = params[key];
      }
    }
  }
  return arr.join('/');
};

/**
 * Returns the last id in the path, using match.params to
 * get its value. For example, a path of 'a/:aId/b/:bId/c'
 * would return match.params['bId']. If there is no id, 
 * null will be returned.
 */
const getLastId = (path, match) => {
  const {
    params
  } = match;
  // eslint-disable-next-line react/destructuring-assignment
  const arr = path.split('/');
  for (let n = arr.length - 1; n > 0; n--) {
    if (arr[n][0] === ':') {
      const key = arr[n].substring(1);
      return params[key];
    }
  }
  return null;
};
export default {
  resolve,
  getLastId
};